if (!customElements.get("payment-options-widget")) {
  customElements.define(
    "payment-options-widget",
    class PaymentOptionsWidget extends HTMLElement {
      constructor() {
          super();
          this.subscriptionOption = this.querySelector('.subscription_option');
          this.onetimeOption = this.querySelector('.onetime_option');
          this.isSubscription = true;
          this.oneTimeProductId = this.getAttribute('one-time-product-id');
          this.oneTimeVariantId = this.getAttribute('one-time-variant-id');
      }
  
      connectedCallback() {
          this.subscriptionOption.addEventListener('click', this.activeOption.bind(this));
          this.onetimeOption.addEventListener('click', this.activeOption.bind(this));
      }
  
      activeOption(event) {
          this.clearOptions();
          const target = event.target.closest('.option_wrapper');
          if (!target) return;
          target.classList.add('selected');
          const deliveryFrequencyWidget = document.querySelector('delivery-frequency-widget');
          const quantitySelector = document.querySelector('.qty-btn-section');
          if (deliveryFrequencyWidget && target.classList.contains('onetime_option')) {
              deliveryFrequencyWidget.close();
              deliveryFrequencyWidget.hide();
              this.isSubscription = false;
              const customizableAssortment = document.querySelector('customizable-assortment');
              if (customizableAssortment && this.productAbsorbencyQuantity > 0) {
                  customizableAssortment.maxAbsorbencyQuantity = this.productAbsorbencyQuantity;
                  customizableAssortment.resetAbsorbency();
                  customizableAssortment.updateProgressBar();
                  customizableAssortment.updateAbsorbencyData();
                  customizableAssortment.updateStatuSubmit();
              }
              const rechargeBundleVariantOptions = document.querySelector('recharge-bundle-variant-options');
              if (rechargeBundleVariantOptions) {
                  rechargeBundleVariantOptions.maxAbsorbencyQuantity = this.productAbsorbencyQuantity;
              }
          } else {
              deliveryFrequencyWidget.show();
              this.isSubscription = true;
              if (deliveryFrequencyWidget.selectedOption) {
                    //update recharge-bundle-variant-options
                    deliveryFrequencyWidget.updateMaxQuantity();
                    //update customizable-assortment
                    deliveryFrequencyWidget.updateCustomizableAssortment();
              }
          }
      }
  
      clearOptions() {
          this.onetimeOption.classList.remove('selected');
          this.subscriptionOption.classList.remove('selected');
      }
  
      updateSubscriptionContent(p, content, absorbencyQty) {
          const price = parseInt(p)
          const absorbencyQuantity = parseInt(absorbencyQty)
          const title = this.querySelector('.option_title .h4');
          title.innerHTML = "$" + parseFloat(price / 100).toFixed(2) + "/" + content;
          const discountMessage = this.querySelector('.discount_message');
          let discount = (this.productOriginalPrice / this.productAbsorbencyQuantity - price / absorbencyQuantity) / this.productOriginalPrice * this.productAbsorbencyQuantity;
          discount = parseInt(discount * 100) + "%";
          discountMessage.innerHTML = 'Up to ' + discount + ' off';
      }
  
      get productOriginalPrice() {
          return parseInt(this.getAttribute('product-original-price'))
      }
      get productAbsorbencyQuantity() {
          return parseInt(this.getAttribute('product-aborbency-quantity'));
      }
    }
  );
}

if (!customElements.get("delivery-frequency-widget")) {
  customElements.define(
    "delivery-frequency-widget",
    class DeliveryFrequencyWidget extends HTMLElement {
      constructor() {
          super();
  
          this.preview = this.querySelector('.frequency_selected_preview');
          this.selector = this.querySelector('.frequency-options-wrapper');
          this.options = this.selector.querySelectorAll('.frequency_option');
          this.selectedProductId = this.getAttribute('data-product-id');
          this.selectedVariantId = this.getAttribute('data-variant-id');
          this.sellingPlan = this.getAttribute('data-selling-plan');
          this.frequency = this.getAttribute('data-frequency');
          this.internalUnit = this.getAttribute('data-interunal_unit');
      }
  
      connectedCallback() {
          this.preview.addEventListener('click', () => {
              this.selector.classList.toggle('expanded');
          });
          this.options.forEach(option => option.addEventListener('click', this.handleOptionClick.bind(this)));
  
  
          // Update discount message
          const selectedOption = Array.from(this.options).find(option => option.classList.contains('selected'));
          if (selectedOption) {
              const price = selectedOption.getAttribute('data-price');
              const absorbencyQuantity = selectedOption.getAttribute('data-absorbency-quantity');
              
              const paymentOptionsWidget = document.querySelector('payment-options-widget');
              let discount = (paymentOptionsWidget.productOriginalPrice / paymentOptionsWidget.productAbsorbencyQuantity - price / absorbencyQuantity) / paymentOptionsWidget.productOriginalPrice * paymentOptionsWidget.productAbsorbencyQuantity;
              const discountMessage = paymentOptionsWidget.querySelector('.discount_message');
              discount = parseInt(discount * 100) + "%";
              discountMessage.innerHTML = 'Up to ' + discount + ' off';
          }
  
      }
  
      handleOptionClick(event) {
          this.selectedOption = event.target.closest('.frequency_option');
          this.updateOptions();
          this.updatePreview();
          this.updatePaymentOptions();
          this.updateMaxQuantity();
          this.updateCustomizableAssortment();
          this.updateProductAndVariant();
          this.close();
      }
  
      updateOptions() {
          this.options.forEach(option => {
              if (option == this.selectedOption) {
                  option.classList.add('selected');
              } else {
                  option.classList.remove('selected');
              }
          })
      }
  
      updatePreview() {
          const previewDetails = this.preview.querySelector('.details');
          const update = this.selectedOption.querySelector('.details');
          if (update && previewDetails) {
              previewDetails.innerHTML = update.innerHTML;
          }
          const previewBoxInfo = this.preview.querySelector('.box-info');
          const updateBoxInfo = this.selectedOption.querySelector('.box-info');
          if (updateBoxInfo && previewBoxInfo) {
              previewBoxInfo.innerHTML = updateBoxInfo.innerHTML;
          }
      }
  
      updateProductAndVariant() {
          this.selectedProductId = this.selectedOption.getAttribute('data-product-id');
          this.selectedVariantId = this.selectedOption.getAttribute('data-variant-id');
          this.sellingPlan = this.selectedOption.getAttribute('data-selling-plan');
          this.frequency = this.selectedOption.getAttribute('data-frequency');
      }
  
      updatePaymentOptions() {
          const price = this.selectedOption.getAttribute('data-price');
          const title = this.selectedOption.getAttribute('data-title');
          const absorbencyQty = this.selectedOption.getAttribute('data-absorbency-quantity');
          const paymentOptionsWidget = document.querySelector('payment-options-widget');
          if (!paymentOptionsWidget) return;
          paymentOptionsWidget.updateSubscriptionContent(price, title, absorbencyQty);
      }
  
      updateMaxQuantity() {
          const maxAbsorbencyQuantity = parseInt(this.selectedOption.getAttribute('data-absorbency-quantity'));
          const rechargeBundleVariantOptions = document.querySelector('recharge-bundle-variant-options');
          if (rechargeBundleVariantOptions) {
              rechargeBundleVariantOptions.maxAbsorbencyQuantity = maxAbsorbencyQuantity;
          }
      }

      updateCustomizableAssortment() {
        const maxAbsorbencyQuantity = parseInt(this.selectedOption.getAttribute('data-absorbency-quantity'));
        const customizableAssortment = document.querySelector('customizable-assortment');
        if (customizableAssortment && maxAbsorbencyQuantity > 0) {
            customizableAssortment.maxAbsorbencyQuantity = maxAbsorbencyQuantity;
            customizableAssortment.resetAbsorbency();
            customizableAssortment.updateProgressBar();
            customizableAssortment.updateAbsorbencyData();
            customizableAssortment.updateStatuSubmit();
        }
      }
  
      close() {
          this.selector.classList.remove('expanded');
      }
  
      open() {
          this.selector.classList.add('expanded');
      }
  
      hide() {
          this.classList.add('hide');
      }
  
      show() {
          this.classList.remove('hide');
      }
    }
  );
}

if (!customElements.get("recharge-bundle-variant-options")) {
  customElements.define(
    "recharge-bundle-variant-options",
    class rechargeBundleVariantOptions extends HTMLElement {
      constructor() {
          super();
          this.maxAbsorbencyQuantity = parseInt(this.getAttribute('product-absorbency-quantity'));
          this.rechargeBundleCollectionId = this.getAttribute('recharge-bundle-collection-id');
          this.rechargeBundleSubProductId = this.getAttribute('recharge-bundle-sub-product-id');
          this.optionName =  this.getAttribute('recharge-bundle-sub-product-option-name');
          this.inputs = this.querySelectorAll('input[name="variant"]');
      }
  
      connectedCallback() {
          this.variantId = this.querySelector('input[name="variant"]').value;
          this.variantTitle = this.querySelector('input[name="variant"]').getAttribute('data-variant-title');
          this.presetVariantData();// ONLY working with subscription page in Customer Portal.
          this.querySelectorAll('input[name="variant"]').forEach(input => input.addEventListener('change', this.handleChange.bind(this)));
          const rechargeSubProductVariants = this.querySelector('[type="application/json"]');
          this.rechargeSubProductVariants = JSON.parse(rechargeSubProductVariants.textContent);
      }

      presetVariantData(){
        const assortmentSettings = document.querySelector('.assortment_setting');
        if(!assortmentSettings) return;
        const variantTitle = assortmentSettings.querySelector('.sub-product-variant')?.getAttribute('data-value');
        this.inputs.forEach(input => {
          const inputVariantTitle = input.getAttribute('data-variant-title');
          if(variantTitle == inputVariantTitle){
            this.variantId = input.value;
            this.variantTitle = input.getAttribute('data-variant-title');
            input.click();
          }
        });
      }

      handleChange(e) {
        const target = e.target;
        this.variantId = target.value;
        this.variantTitle = target.getAttribute('data-variant-title');
      }
    }
  );
}


if (!customElements.get("recharge-bundle-edit-subscription")) {
  customElements.define(
    "recharge-bundle-edit-subscription",
    class RechargeBundleEditSubscription extends HTMLElement {
      constructor() {
          super();
          this.button = this.querySelector('button');
          this.referencedProductHandle = this.getAttribute('data-referenced-product-handle');
          this.storeIdentifier = this.getAttribute('data-store-identifier');
          this.subscriptionId = document.querySelector('input[name="subscription_id"]')?.value;
      }
  
      async connectedCallback() {
          recharge.init({
              storeIdentifier: this.storeIdentifier, // On Shopify this should be your myshopify.com domain
              // required for Storefront API access
              storefrontAccessToken: 'strfnt_f16386bfed7c30d02ab8e5bbd1f6286eaa93d2e54cca7c33875c6ead2007f2c7'
          });
          this.button.addEventListener('click', this.handleSubmit.bind(this));
          this.deliveryFrequencyWidget = document.querySelector('delivery-frequency-widget');
          this.rechargeBundleVariantOptions = document.querySelector('recharge-bundle-variant-options');
          this.paymentOptionsWidget = document.querySelector('payment-options-widget');
      }
  
      async handleSubmit(e) {
          e.preventDefault();
          if (!this.subscriptionId) return;
  
          if (this.button.classList.contains('disabled')) return;
  
          this.button.classList.add('loading');
          this.button.classList.add('disabled');
  
          const bundleParentData = {
              variantId: this.deliveryFrequencyWidget.selectedVariantId,
              productId: this.deliveryFrequencyWidget.selectedProductId,
              sellingPlan: this.deliveryFrequencyWidget.sellingPlan,
              frequency: parseInt(this.deliveryFrequencyWidget.frequency),
              internalUnit: this.deliveryFrequencyWidget.internalUnit
          }
  
          const bundleCollectionId = this.rechargeBundleVariantOptions.rechargeBundleCollectionId;
          const bundleSubProductId = this.rechargeBundleVariantOptions.rechargeBundleSubProductId;
          const selections = [];
          const properties = [];
          
          const data = {};
          data.collection_id = bundleCollectionId;
          data.collection_source = 'shopify';
          data.external_product_id = bundleSubProductId;
          data.quantity = parseInt(this.rechargeBundleVariantOptions.maxAbsorbencyQuantity);
          data.external_variant_id = this.rechargeBundleVariantOptions.variantId;
          selections.push(data);
          properties.push({
              name: '_referenced_product_handle',
              value: `${this.referencedProductHandle}`
          })

          if(this.rechargeBundleVariantOptions.variantTitle && this.rechargeBundleVariantOptions.optionName != ''){
            properties.push({
                name: `${this.rechargeBundleVariantOptions.optionName}`,
                value: this.rechargeBundleVariantOptions.variantTitle
            })
          }
  
          const bundle = {
              properties: properties,
              external_product_id: { ecommerce: bundleParentData.productId.toString() },
              external_variant_id: { ecommerce: bundleParentData.variantId.toString() },
              items: selections,
              charge_interval_frequency: bundleParentData.frequency,
              order_interval_frequency: bundleParentData.frequency,
              order_interval_unit: bundleParentData.internalUnit
          };
          console.log('bundle', bundle);
          try {
              const session = await recharge.auth.loginShopifyAppProxy();
              const result = await recharge.bundle.updateBundle(session, this.subscriptionId, bundle);
              console.log(result);
              window.location.href = window.LOLA_PRODUCT.metadata.rechargeInfo.subscriptionsListUrl;
          } catch (error) {
              console.log(error);
          }
      }
  
  }
  );
}

if (!customElements.get("recharge-bundle-add-to-cart")) {
  customElements.define(
      "recharge-bundle-add-to-cart",
      class RechargeBundleAddToCart extends HTMLElement {
          constructor() {
              super();
              this.button = this.querySelector('button');
              this.referencedProductHandle = this.getAttribute('data-referenced-product-handle');
              this.storeIdentifier = this.getAttribute('data-store-identifier');
          }
      
          connectedCallback() {
              recharge.init({ storeIdentifier: this.storeIdentifier });
              this.button.addEventListener('click', this.handleSubmit.bind(this));
              this.deliveryFrequencyWidget = document.querySelector('delivery-frequency-widget');
              this.rechargeBundleVariantOptions = document.querySelector('recharge-bundle-variant-options');
              this.paymentOptionsWidget = document.querySelector('payment-options-widget');
          }
      
          async handleSubmit(e) {
              e.preventDefault();
      
              if (this.button.classList.contains('disabled')) return;
      
              let bundleParentData;
              const quantity = document.querySelector('.qty-btn-section select[name="quantity"]');
              if (this.paymentOptionsWidget.isSubscription) {
                  bundleParentData = {
                      variantId: this.deliveryFrequencyWidget.selectedVariantId,
                      productId: this.deliveryFrequencyWidget.selectedProductId,
                      sellingPlan: this.deliveryFrequencyWidget.sellingPlan,
                      quantity: quantity ? quantity.value : 1
                  }
              } else {
                  bundleParentData = {
                      variantId: this.paymentOptionsWidget.oneTimeVariantId,
                      productId: this.paymentOptionsWidget.oneTimeProductId,
                      sellingPlan: null,
                      quantity: quantity ? quantity.value : 1
                  }
              }
      
              const bundleCollectionId = this.rechargeBundleVariantOptions.rechargeBundleCollectionId;
              const bundleSubProductId = this.rechargeBundleVariantOptions.rechargeBundleSubProductId;
              const selections = [];
              const properties = {};
              
              const data = {};
              data.collectionId = bundleCollectionId;
              data.externalProductId = bundleSubProductId;
              data.quantity = parseInt(this.rechargeBundleVariantOptions.maxAbsorbencyQuantity);
              data.externalVariantId = this.rechargeBundleVariantOptions.variantId;
              selections.push(data);
      
              const bundle = {
                  "externalVariantId": bundleParentData.variantId,
                  "externalProductId": bundleParentData.productId,
                  "selections": selections
              };
      
              console.log(bundle)
              const rbId = await recharge.bundle.getBundleId(bundle);
      
              // Adds the value directly to the cart
              properties['_rb_id'] = rbId;
              properties['_referenced_product_handle'] = this.referencedProductHandle;
              if(this.rechargeBundleVariantOptions.variantTitle && this.rechargeBundleVariantOptions.optionName != ''){
                properties[`${this.rechargeBundleVariantOptions.optionName}`] = this.rechargeBundleVariantOptions.variantTitle;
              }
              const cartData = {
                  items: [{
                      id: bundleParentData.variantId,
                      quantity: bundleParentData.quantity,
                      properties: properties,
                      selling_plan: bundleParentData.sellingPlan
                  }]
              };

              const upsellProductElement = document.querySelector(
                ".upsell-product--wrapper .add-form-selector"
              );

              if (
                upsellProductElement &&
                upsellProductElement.classList.contains("active") &&
                upsellProductElement.hasAttribute("data-variant-id")
              ) {
                  const upsell_data = {
                      items: [
                          {
                              quantity: 1,
                              id: upsellProductElement.getAttribute("data-variant-id"),
                          },
                      ],
                  };

                  try {
                      const addOnResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
                          method: "POST",
                          headers: {
                              "Content-Type": "application/json",
                          },
                          body: JSON.stringify(upsell_data),
                      })
                  } catch (e) {
                      console.error("Error adding add-on:", e);
                  }
              }
              
      
              const result = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(cartData),
              });
          }
      }
  );
}

if (!customElements.get("recharge-bundle-add-subscription")) {
    customElements.define(
        "recharge-bundle-add-subscription",
        class RechargeBundleAddSubscription extends HTMLElement {
            constructor() {
                super();
                this.button = this.querySelector('button');
                this.referencedProductHandle = this.getAttribute('data-referenced-product-handle');
                this.storeIdentifier = this.getAttribute('data-store-identifier');
            }
        
            async connectedCallback() {
                recharge.init({
                    storeIdentifier: this.storeIdentifier, // On Shopify this should be your myshopify.com domain
                    // required for Storefront API access
                    storefrontAccessToken: 'strfnt_f16386bfed7c30d02ab8e5bbd1f6286eaa93d2e54cca7c33875c6ead2007f2c7'
                });
                this.button.addEventListener('click', this.handleSubmit.bind(this));
                this.deliveryFrequencyWidget = document.querySelector('delivery-frequency-widget');
                this.rechargeBundleVariantOptions = document.querySelector('recharge-bundle-variant-options');
                this.paymentOptionsWidget = document.querySelector('payment-options-widget');
            }
        
            async handleSubmit(e) {
                e.preventDefault();
        
                if (this.button.classList.contains('disabled')) return;
        
                this.button.classList.add('loading');
                this.button.classList.add('disabled');
        
                const bundleParentData = {
                    variantId: this.deliveryFrequencyWidget.selectedVariantId,
                    productId: this.deliveryFrequencyWidget.selectedProductId,
                    sellingPlan: this.deliveryFrequencyWidget.sellingPlan,
                    frequency: parseInt(this.deliveryFrequencyWidget.frequency),
                    internalUnit: this.deliveryFrequencyWidget.internalUnit
                }
        
                const bundleCollectionId = this.rechargeBundleVariantOptions.rechargeBundleCollectionId;
                const bundleSubProductId = this.rechargeBundleVariantOptions.rechargeBundleSubProductId;
                const selections = [];
                const properties = [];
                
                const data = {};
                data.collection_id = bundleCollectionId;
                data.collection_source = 'shopify';
                data.external_product_id = bundleSubProductId;
                data.quantity = parseInt(this.rechargeBundleVariantOptions.maxAbsorbencyQuantity);
                data.external_variant_id = this.rechargeBundleVariantOptions.variantId;
                selections.push(data);
                properties.push({
                    name: '_referenced_product_handle',
                    value: `${this.referencedProductHandle}`
                })
        
                const addressId = document.querySelector('#select_address_id').value;
                const next_charge_scheduled_at = document.querySelector('#next_charge_date').value;

                const subscription = {
                    properties: properties,
                    external_product_id: { ecommerce: bundleParentData.productId.toString() },
                    external_variant_id: { ecommerce: bundleParentData.variantId.toString() },
                    quantity: 1,
                    charge_interval_frequency: bundleParentData.frequency,
                    order_interval_frequency: bundleParentData.frequency,
                    order_interval_unit: bundleParentData.internalUnit,
                    address_id: addressId,
                    next_charge_scheduled_at: next_charge_scheduled_at,
                };

                const bundle = {
                    properties: properties,
                    external_product_id: { ecommerce: bundleParentData.productId.toString() },
                    external_variant_id: { ecommerce: bundleParentData.variantId.toString() },
                    items: selections,
                    charge_interval_frequency: bundleParentData.frequency,
                    order_interval_frequency: bundleParentData.frequency,
                    order_interval_unit: bundleParentData.internalUnit
                };
                console.log('bundle', bundle);
                try {
                    const session = await recharge.auth.loginShopifyAppProxy();
                    //create subscription
                    const newSubscription = await recharge.subscription.createSubscription(session, subscription);
                    const subscriptionID = newSubscription.id;

                    const updateSubscription = await recharge.bundle.updateBundle(session, subscriptionID, bundle);
                    //update bunlde children items. 
                    console.log('newSubscription', newSubscription);
                    console.log('updateSubscription', updateSubscription);
                    window.location.href = window.LOLA_PRODUCT.metadata.rechargeInfo.subscriptionsListUrl;
                } catch (error) {
                    console.log(error);
                }
            }

        }
    );
}